import { useState, useMemo, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { Box, InputBase, IconButton, Backdrop, CircularProgress } from '@material-ui/core';
import moment from 'moment';
import { Droppable } from 'react-beautiful-dnd';
import { store } from '../../../../redux';
import { SearchIcon, FilterIcon, AddIcon, CloseIcon, DateIcon } from '../../../../components/Icon';
import Card from '../../../../components/StaffCard/drag';
import { Dialog } from '../../../../components';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import { checkSubmitData } from '../TemplateEdit/list';
import { classNames } from '../../../../utils';
import CustomButton from '../../../../components/Button';
import { authNameE } from '../../../../utils/userFuncs';
import Filter from './filter';
import Time from './time';
import Group from './group';
import Upload, { base64ToBlobDownload } from './Upload';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0',
    position: 'absolute',
    paddingTop: '4.375rem',
    right: 0,
    bottom: '0',
    width: '19.438rem',
    backgroundColor: theme.palette.font.white,
    boxShadow: '0 0 0.75rem 0 #d2d7e0',
    overflowY: 'hidden',
    maxheight: '50rem',
    height: '100%',
    overflow: 'hidden',
    '&:hover': {
      overflowY: 'auto',
    },
  },
  head: {
    padding: '1.875rem 0 0.875rem',
    width: '100%',
    borderBottom: '0.075rem solid #e4e7eb',
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.336rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '500',
    margin: '0 0 1.438rem 1.25rem',
  },
  search: {
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.font.white,
    width: '9.813rem',
    height: '2.375rem',
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: '1.2rem',
    border: '0.0625rem solid #ddd',
  },
  input: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.919rem',
    letterSpacing: '0',
    color: theme.palette.font.sub,
    fontWeight: '500',
    margin: '0 0.938rem 0 0.938rem',
  },
  iconbtn: {
    padding: '0',
  },
  icon: {
    backgroundColor: '#4c93ff',
    color: theme.palette.font.white,
    padding: '0.5rem 0.5rem 0.438rem 0.438rem',
    borderRadius: '0.4875rem',
    fontSize: '1.875rem',
    margin: '0.313rem 0.313rem 0.313rem 0',
  },
  filter: {
    padding: '0.5rem 0.563rem 0.5rem 0.625rem',
    borderRadius: '0.5rem',
    boxShadow: '-0.0625rem 0.25rem 0.625rem 0 rgba(221, 232, 251, 0.58)',
    height: '2.5rem',
    textTransform: 'inherit',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.919rem',
    letterSpacing: '0',
    color: theme.palette.font.sub,
    backgroundColor: theme.palette.font.white,
    fontWeight: '500',
    border: '0.0625rem solid #e4e7eb',
  },
  filtericon: {
    fontSize: '1.25rem',
    marginRight: '0.5rem',
    color: theme.palette.primary.main,
  },
  btn: {
    display: 'flex',
    marginLeft: '1.25rem',
  },
  list: {
    padding: '1.188rem 0 0 1.563rem',
  },
  listtitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginBottom: '1.188rem',
  },
  foot: {
    // padding: '0.875rem 0 0.938rem 2.25rem',
    padding: '0.875rem 0 0 2.25rem',
    boxShadow: '0 -0.0625rem 0 0 #e4e7eb',
    borderTop: '0.075rem solid #e4e7eb',
    // height: '8.3rem',
  },
  footbody: {
    width: '15.75rem',
  },
  addbtn: {
    width: '100%',
    height: '3rem',
    backgroundColor: 'rgba(83, 143, 255, 0.1)',
    borderRadius: '0.625rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(83, 143, 255, 0.1)',
    },
  },
  addicon: {
    fontSize: '1.125rem',
    color: theme.palette.primary.main,
    marginRight: '0.75rem',
  },
  group: {
    width: '12.25rem',
    height: '2.5rem',
    borderRadius: '0.5rem',
    border: '0.0625rem solid #538fff',
    marginBottom: '1.25rem',
    padding: '0 0.625rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  grouptext: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: '0',
    color: theme.palette.primary.main,
    fontWeight: '500',
  },
  groupBtn: {
    width: '1.375rem',
    height: '1.375rem',
    borderRadius: '0',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  groupIcon: {
    fontSize: '0.938rem',
    color: theme.palette.primary.main,
  },
  dialogTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
  dialogTitleRequired: {
    paddingLeft: '.3rem',
    color: 'red',
  },
  dialogRank: {
    width: '19.375rem',
  },
  dialogBodyinput: {
    width: '19.375rem',
    borderRadius: '0.625rem',
    border: '0.0625rem solid #e4e7eb',
    display: 'flex',
    justifyContent: 'center',
    height: '3.5rem',
    padding: '0 1.25rem 0 1.25rem',
    '& .MuiInputBase-input': {
      padding: '0',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      height: '1.5rem',
    },
  },
  dialogBody: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogHead: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogBodyFrom: {
    display: 'flex',
  },
  dialogBodyline: {
    width: '2.188rem',
    height: '2.063rem',
    color: theme.palette.primary.main,
    marginTop: '2.5rem',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    letterSpacing: '0',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  dialogBodyDatePicker: {
    width: '100%',
    '& .MuiInputBase-root': {
      padding: '0 0.625rem 0 1.25rem',
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '19.375rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
  },
  Picon: {
    fontSize: '1.375rem',
    color: theme.palette.primary.main,
  },
  datePickerError: {
    '& .MuiInputBase-root': {
      borderColor: '#f44336 !important',
    },
  },
  error: {
    borderColor: '#f44336 !important',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginTop: '0.5rem',
  },
  backdrop: {
    zIndex: theme.zIndex.tooltip + 1,
    color: theme.palette.primary.main,
  },
}));

const handleDate = (props, setValue) => {
  if (props?.['_i'] && props?.['_i']?.[9] === '_') {
    setValue(null);
    return;
  }
  setValue(props);
};

export const DialogBody = ({
  rankValue,
  handleRank,
  inputValue,
  handleInput,
  corpId,
  handleCorpId,
  employeeId,
  handleEmployeeId,
  startTime,
  handleStartTime,
  endTime,
  handleEndTime,
  error,
  setError,
}) => {
  const classes = useStyles();
  const [rankCode, setRankCode] = useState([]);

  const nameSchema = {
    name: Yup.string()
      .max(20, i18n.t('DUTYASSIGN_CHECK_TITLE_LENGTH', { value: 20 }))
      .required(i18n.t('DUTYASSIGN_CHECK_TITLE_MSG', { value: i18n.t('DUTYASSIGN_CHECK_NAME') })),
    rank: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_TEMPLATE_RANK') })
    ),
    startDate: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_CHECK_START_TIME') })
    ),
    endDate: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_CHECK_END_TIME') })
    ),
  };

  const focusCheck = (name, value) => {
    return async () => {
      try {
        await checkSubmitData(Yup.object().shape({ [name]: nameSchema[name] }), { [name]: value });
        setError({ ...error, [name]: null });
      } catch (e) {
        setError({ ...error, ...e });
      }
    };
  };

  // get rank API
  const getRankListAPI = useCallback(async () => {
    try {
      const { result } = await dutyAssignAPI.getRankList();
      setRankCode(result);
    } catch (error) {
      console.log('-----Get SrsWard error----->', error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getRankListAPI();
    })();
  }, [getRankListAPI]);

  const rankList = useMemo(() => {
    let list = [];

    if (Array.isArray(rankCode) && rankCode.length > 0) {
      list = _.map(rankCode, (item) => {
        return {
          value: item,
          text: item,
        };
      });
    }

    return list;
  }, [rankCode]);

  const handleRankOnOpen = () => {
    if (rankList.length === 0) {
      (async () => {
        await getRankListAPI();
      })();
    }
  };

  return (
    <div>
      <div className={classes.dialogHead}>
        <div>
          <div className={classes.dialogTitle} id="duty-assign-staff-rank-label">
            {i18n.t('DUTYASSIGN_ROSTER_ADD_RANK_TITLE')}
            <span className={classes.dialogTitleRequired}>*</span>
          </div>
          <AutoCompleteInput
            className={classes.dialogRank}
            inputFlag={true}
            itemList={rankList}
            value={rankValue}
            onChange={(data) => {
              handleRank(data);
            }}
            id="DutyAssign-AutoCompleteInput-aca"
            onOpen={handleRankOnOpen}
            placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_RANK_INPUT')}
            onBlur={focusCheck('rank', rankValue)}
            errorMsg={error?.rank}
          />
        </div>
        <div
          style={{
            marginBottom: '1.375rem',
          }}
        >
          <div className={classes.dialogTitle} id="duty-assign-staff-name-label">
            {i18n.t('DUTYASSIGN_ROSTER_ADD_NAME_TITLE')}
            <span className={classes.dialogTitleRequired}>*</span>
          </div>
          <InputBase
            className={error?.name ? classNames(classes.dialogBodyinput, classes.error) : classes.dialogBodyinput}
            value={inputValue}
            onChange={(event) => {
              handleInput(event.target.value);
            }}
            id="DutyAssign-InputBase-acb"
            placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_NAME_INPUT')}
            onBlur={() => {
              (async () => {
                await focusCheck('name', inputValue)();
              })();
            }}
          />
          {error?.name && <div className={classes.errorMsg}>{error?.name ?? ''}</div>}
        </div>
      </div>
      <div className={classes.dialogBody}>
        <div style={{ marginBottom: '1.375rem' }}>
          <div className={classes.dialogTitle} id="duty-assign-staff-corpid-label">
            {i18n.t('DUTYASSIGN_ROSTER_ADD_CORP_ID_TITLE')}
          </div>
          <InputBase
            className={classes.dialogBodyinput}
            value={corpId || ''}
            onChange={(event) => {
              handleCorpId(event.target.value);
            }}
            id="DutyAssign-InputBase-corp-id"
            placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_CORP_ID_INPUT')}
            onBlur={() => {
              (async () => {
                await focusCheck('corpId', corpId)();
              })();
            }}
          />
        </div>
        <div style={{ marginBottom: '1.375rem' }}>
          <div className={classes.dialogTitle} id="duty-assign-staff-employeeid-label">
            {i18n.t('DUTYASSIGN_ROSTER_ADD_EMPLOYEE_ID_TITLE')}
          </div>
          <InputBase
            className={classes.dialogBodyinput}
            value={employeeId || ''}
            onChange={(event) => {
              handleEmployeeId(event.target.value);
            }}
            id="DutyAssign-InputBase-employee-id"
            placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_EMPLOYEE_ID_INPUT')}
            onBlur={() => {
              (async () => {
                await focusCheck('employeeId', employeeId)();
              })();
            }}
          />
        </div>
      </div>
      <div className={classes.dialogBody}>
        <div>
          <div className={classes.dialogTitle} id="duty-assign-staff-date-from-label">
            {i18n.t('DUTYASSIGN_ROSTER_ADD_START_TITLE')}
            <span className={classes.dialogTitleRequired}>*</span>
          </div>
          <div className={classes.dialogBodyFrom}>
            <KeyboardDatePicker
              className={
                error?.startDate
                  ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                  : classes.dialogBodyDatePicker
              }
              keyboardIcon={<DateIcon className={classes.Picon} />}
              value={startTime}
              onChange={(event) => handleDate(event, handleStartTime)}
              id="DutyAssign-KeyboardDatePicker-acc"
              variant="dialog"
              format="DD-MM-yyyy"
              inputVariant="outlined"
              InputAdornmentProps={{ position: 'end', id: 'duty-assign-staff-date-from-button' }}
              placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_START_INPUT')}
              onBlur={() => {
                (async () => {
                  await focusCheck('startDate', startTime ?? '')();
                })();
              }}
            />
          </div>
          {error.startDate && <div className={classes.errorMsg}>{error?.startDate}</div>}
        </div>
        <div className={classes.dialogBodyline}>-</div>
        <div>
          <div className={classes.dialogTitle} id="duty-assign-staff-date-to-label">
            {i18n.t('DUTYASSIGN_ROSTER_ADD_END_TITLE')}
            <span className={classes.dialogTitleRequired}>*</span>
          </div>
          <KeyboardDatePicker
            className={
              error?.endDate
                ? classNames(classes.dialogBodyDatePicker, classes.datePickerError)
                : classes.dialogBodyDatePicker
            }
            keyboardIcon={<DateIcon className={classes.Picon} />}
            value={endTime}
            onChange={(event) => handleDate(event, handleEndTime)}
            id="DutyAssign-KeyboardDatePicker-acd"
            variant="dialog"
            format="DD-MM-yyyy"
            inputVariant="outlined"
            InputAdornmentProps={{ position: 'end', id: 'duty-assign-staff-date-to-button' }}
            placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_END_INPUT')}
            minDate={new Date(startTime)}
            onBlur={() => {
              (async () => {
                await focusCheck('endDate', endTime ?? '')();
              })();
            }}
          />
          {error.endDate && <div className={classes.errorMsg}>{error?.endDate}</div>}
        </div>
      </div>
      <div style={{ marginTop: '0.625rem' }} id="DutyAssign-message">
        <span style={{ color: 'red', fontSize: '1rem' }}>{'* '}</span>
        <span style={{ color: 'black', fontSize: '1rem', fontStyle: 'italic' }}>
          {i18n.t('BEDSTATUS_STAR_IS_REQUIRED_FIELD')}
        </span>
      </div>
    </div>
  );
};

export default function DutyRoster({ publishCtrl, getStaffListAPI, rouList, rosterData, setrosterRefresh, smartComm }) {
  const classes = useStyles();
  const [open, setopen] = useState(true);
  const [groupopen, setgroupopen] = useState(false);
  const [timeopen, settimeopen] = useState(false);
  const [dialogFromTime, handleDialogFromTimeChange] = useState(null);
  const [dialogToTime, handleDialogToTimeChange] = useState(null);
  const [addUsername, handleAddUsername] = useState('');
  const [groupfilter, setGroupFilter] = useState(false);
  const [time, setTime] = useState(false);
  const [startTime, setStartTime] = useState(false);
  const [endTime, setEndTime] = useState(false);
  const [filter, setFilter] = useState('');
  const [rankValue, setRankValue] = useState('');
  const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
  const rosterDate = dutyDateInfo?.date ?? moment();
  const rosterId = dutyDateInfo?.id ?? 0;
  const [error, setError] = useState({});

  const [corpId, setCorpId] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const enableSmartComm = smartComm; 
  const resetAPI = () => {
    if (filter.length > 0 || groupfilter || startTime || endTime) {
      setFilter('');
      setGroupFilter(false);
      setStartTime(false);
      setEndTime(false);
      setTime(false);
    }
    (async () => {
      await getStaffListAPI({});
    })();
  };

  useEffect(() => {
    resetAPI();
  }, [rosterDate, rosterId, rouList]);

  useEffect(() => {
    setrosterRefresh((o) => !o);
  }, [groupfilter, time]);

  // create Temporary API
  const createStaffAPI = async (name, startDate, endDate, rankCode, corpId, employeeId) => {
    try {
      await dutyAssignAPI.postCteateTemporaryStaff({
        endDate:
          moment(moment(endDate, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'), 'YYYY-MM-DD kk:mm:ss').unix() * 1000,
        name,
        startDate:
          moment(moment(startDate, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'), 'YYYY-MM-DD kk:mm:ss').unix() * 1000,
        rankCode,
        corpId,
        employeeId,
      });
      resetAPI();
    } catch (error) {
      console.log('-----Create Temporary error----->', error);
    }
  };

  // delete Temporary API
  const deleteStaffAPI = async (id) => {
    try {
      await dutyAssignAPI.postDeleteTemporaryStaff({ id });
      resetAPI();
    } catch (error) {
      console.log('-----Delete Temporary error----->', error);
    }
  };

  // edit Temporary API
  const updateStaffAPI = async (dutyTempUserId, endDate, name, startDate, rankCode, corpId, employeeId) => {
    try {
      await dutyAssignAPI.postUpdateTemporaryStaff({
        dutyTempUserId,
        endDate:
          moment(moment(endDate, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'), 'YYYY-MM-DD kk:mm:ss').unix() * 1000,
        name,
        startDate:
          moment(moment(startDate, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'), 'YYYY-MM-DD kk:mm:ss').unix() * 1000,
        rankCode,
        corpId,
        employeeId,
      });
      window.postMessage({
        topic: 'browser',
        action: 'reload',
      });
    } catch (error) {
      console.log('-----Edit Temporary error----->', error);
    }
  };

  const [dialogOpen, setdialogOpen] = useState(false);

  const handleDialogClose = () => {
    handleAddUsername('');
    setRankValue('');
    setError({});
    handleDialogFromTimeChange(null);
    handleDialogToTimeChange(null);
    setdialogOpen(false);
    setCorpId('');
    setEmployeeId('');
  };

  const [uploadAlert, setUploadAlert] = useState({ open: false, status: '', title: '', content: null });
  const handleUploadAlertOpen = (status, title, content) => setUploadAlert({ open: true, status, title, content });
  const handleUploadAlertClose = () => {
    const { status } = uploadAlert;
    setUploadAlert({ open: false, status: '', title: '', content: '' });
    if (status === 'success') {
      handleUploadDialogClose();
      window.location.reload();
    }
  };

  const [uploads, setUploads] = useState({
    file: null,
    // mode: StaffDuty-0 | StaffOnly-1
    mode: 0,
    // option: Overwrite-0 | Append-1
    option: null,
  });
  const handleUploads = (upload) => setUploads(upload);
  const handleUploadsClear = () => setUploads({ file: null, mode: 0, option: null });
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  const [uploadBackdropShow, setUploadBackdropShow] = useState(false);

  const handleUploadDialogClose = () => {
    setUploadDialogOpen(false);
    handleUploadsClear();
  };
  const handleUploadDialogConfirmButtonDisabled = () => {
    let disabled = true;
    if (uploads.file) {
      if (uploads.mode === 0 || (uploads.mode === 1 && uploads.option !== null)) disabled = false;
    }
    return disabled;
  };
  const handleUploadDialogConfirmButtonClick = async () => {
    const params = {};
    params.fileName = uploads.file.fileName;
    params.fileBase64 = uploads.file.fileBase64;
    params.mode = uploads.mode;
    params.option = uploads.option;
    if (params.mode === 0) delete params.option;
    // dutyStartDate
    const { date } = JSON.parse(sessionStorage.getItem('dutyInfo'));
    const dateStr = `${date.split('T')[0]}T00:00:00`;
    const dutyStartDate = Number(new Date(dateStr));
    params.dutyStartDate = dutyStartDate;
    setUploadBackdropShow(true);
    try {
      const res = await dutyAssignAPI.postTemplateStaff(params, { timeout: 300000, headers: { isHideLoading: true } });
      setUploadBackdropShow(false);
      if (res.statusCode === '0') {
        const alertStatus = 'success';
        const alertTitle = i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_SUCCESS_TITLE');
        handleUploadAlertOpen(alertStatus, alertTitle, i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_SUCCESS_MESSAGE'));
      }
    } catch (error) {
      const { statusCode } = error;
      setUploadBackdropShow(false);
      if (statusCode === '7312') {
        const {
          result: { errorFileBase64, errorFileName },
        } = error;
        const alertStatus = 'fail';
        const alertTitle = i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_ERROR_TITLE');
        const alertContent = (
          <div>
            <div style={{ fontSize: '1.05rem' }}>
              {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_FAIL_HAVE_ERRORS_MESSAGE')}
            </div>
            <div style={{ marginTop: '1.3rem' }}>
              <CustomButton
                fullWidth
                buttonColor="yellow"
                onClick={() => {
                  base64ToBlobDownload(errorFileBase64, errorFileName);
                  handleUploadAlertClose();
                }}
              >
                {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_DOWNLOAD_ERROR_EXCEL_BUTTON_TEXT')}
              </CustomButton>
            </div>
          </div>
        );
        handleUploadAlertOpen(alertStatus, alertTitle, alertContent);
      }
      if (statusCode === '7309') {
        const alertStatus = 'fail';
        const alertTitle = i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_ERROR_TITLE');
        const alertContent = (
          <div>
            <div style={{ fontSize: '1.05rem' }}>
              {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_ERROR_NO_RECORD_MESSAGE')}
            </div>
          </div>
        );
        handleUploadAlertOpen(alertStatus, alertTitle, alertContent);
      }
      if (statusCode === '7310') {
        const {
          result: { warning = [] },
        } = error;
        const alertStatus = 'success';
        const alertTitle = i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_SUCCESS_MESSAGE');
        const thStyle = {
          padding: '.3rem',
          textAlign: 'left',
          color: 'rgb(76, 147, 255)',
          borderBottom: '1px #ddd solid',
        };

        const tdStyle = { borderTop: '1px #ddd solid', padding: '.3rem' };
        const alertContent = (
          <div>
            <div style={{ fontSize: '1.05rem' }}>
              {i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_SUCCESS_NO_CORPID_MESSAGE')}
            </div>
            {warning.length ? (
              <div style={{ marginTop: '1.3rem' }}>
                <div>
                  <table cellPadding="0" cellSpacing="0" style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ ...thStyle, width: '170px' }}>{i18n.t('DUTYASSIGN_ROSTER_ADD_CORP_ID_TITLE')}</th>
                        <th style={thStyle}>{i18n.t('DUTYASSIGN_CHECK_NAME')}</th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div style={{ maxHeight: '205px', overflowY: 'auto' }}>
                  <table cellPadding="0" cellSpacing="0" style={{ width: '100%' }}>
                    <tbody>
                      {warning.map((item) => (
                        <tr key={item.rowIndex}>
                          <td style={{ ...tdStyle, width: '170px' }}>{item.corpId}</td>
                          <td style={tdStyle}>{item.displayName}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
        );
        handleUploadAlertOpen(alertStatus, alertTitle, alertContent);
      }
    }
  };

  const handleDialogConfirm = (input, startTime, endTime, rankValue) => {
    if (handleVerify({ name: input, rank: rankValue, from: startTime, to: endTime })) {
      return;
    }
    (async () => {
      await createStaffAPI(
        input,
        moment(startTime).format('DD-MM-yyyy'),
        moment(endTime).format('DD-MM-yyyy'),
        rankValue,
        corpId,
        employeeId
      );
    })();

    handleAddUsername('');
    setRankValue('');
    setError({});
    handleDialogFromTimeChange(null);
    handleDialogToTimeChange(null);
    setdialogOpen(false);
    setCorpId('');
    setEmployeeId('');
  };

  const handleVerify = ({ name, rank, from, to }) => {
    return Boolean(
      name === '' ||
        rank === '' ||
        from === null ||
        to === null ||
        !moment(moment(from), 'DD-MM-yyyy').isValid() ||
        !moment(moment(to), 'DD-MM-yyyy').isValid() ||
        moment(moment(to)).isBefore(moment(from), 'day') ||
        moment(moment(from)).isBefore('1899-12-31', 'day') ||
        moment(moment(to)).isAfter('2100-01-01', 'day')
    );
  };

  const roleMap = store.getState()?.roleMap || {};

  return (
    <div className={classes.root}>
      {open && (
        <div
          style={{
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
          }}
        >
          <div className={classes.head}>
            <div className={classes.title}>{i18n.t('DUTYASSIGN_ROSTER')}</div>
            <div className={classes.btn}>
              <Box className={classes.search}>
                <InputBase
                  className={classes.input}
                  value={filter}
                  onChange={(event) => {
                    setFilter(event.target.value);
                  }}
                  id="DutyAssign-InputBase-acj"
                  placeholder={i18n.t('DUTYASSIGN_ROSTER_SEARCH')}
                  onKeyDown={(event) => {
                    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
                      filter === ''
                        ? getStaffListAPI({ group: groupfilter, timeStart: startTime, timeEnd: endTime })
                        : getStaffListAPI({ name: filter, group: groupfilter, timeStart: startTime, timeEnd: endTime });
                    }
                  }}
                />
                <IconButton
                  className={classes.iconbtn}
                  onClick={() => {
                    filter === ''
                      ? getStaffListAPI({ group: groupfilter, timeStart: startTime, timeEnd: endTime })
                      : getStaffListAPI({ name: filter, group: groupfilter, timeStart: startTime, timeEnd: endTime });
                  }}
                  id="DutyAssign-IconButton-ack"
                >
                  <SearchIcon className={classes.icon} />
                </IconButton>
              </Box>
              <IconButton className={classes.filter} onClick={() => setopen(false)} id="DutyAssign-IconButton-ack">
                <FilterIcon className={classes.filtericon} />
                {i18n.t('DUTYASSIGN_ROSTER_FILTER')}
              </IconButton>
            </div>
          </div>
          <div
            style={{
              overflow: 'auto',
              overflowX: 'hidden',
            }}
          >
            <div className={classes.list}>
              <div className={classes.listtitle}> {i18n.t('DUTYASSIGN_ROSTER_LIST_TITLE')} </div>
              <Droppable droppableId="roster" isDropDisabled={true}>
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {groupfilter && (
                      <div className={classes.group}>
                        <div className={classes.grouptext}>{`${i18n.t(
                          'DUTYASSIGN_ROSTER_FILTER_GROUP'
                        )} : ${groupfilter}`}</div>
                        <IconButton
                          className={classes.groupBtn}
                          onClick={() => {
                            setGroupFilter(false);
                            getStaffListAPI({ name: filter, timeStart: startTime, timeEnd: endTime });
                          }}
                          id="DutyAssign-IconButton-ace"
                        >
                          <CloseIcon className={classes.groupIcon} />
                        </IconButton>
                      </div>
                    )}
                    {time && (
                      <div className={classes.group}>
                        <div className={classes.grouptext}>{time}</div>
                        <IconButton
                          className={classes.groupBtn}
                          onClick={() => {
                            setTime(false);
                            setStartTime(false);
                            setEndTime(false);
                            getStaffListAPI({ name: filter, group: groupfilter });
                          }}
                          id="DutyAssign-IconButton-acf"
                        >
                          <CloseIcon className={classes.groupIcon} />
                        </IconButton>
                      </div>
                    )}
                    {_.orderBy(rosterData, ['rankOrder', 'name'], ['asc', 'asc']).map((roster, index) => {
                      if (roster.temporary) {
                        return (
                          <Card
                            {...roster}
                            dragIcon={true}
                            dragopen={true}
                            remark={null}
                            longremark={null}
                            outlineColour={0}
                            handleVerify={handleVerify}
                            handleDelete={() => deleteStaffAPI(roster.tempId)}
                            index={index}
                            id={roster.tempId}
                            handleEditTemporarystaff={(id, endDate, name, startDate, rankCode, corpId, employeeId) =>
                              updateStaffAPI(
                                id,
                                moment(endDate).format('DD-MM-yyyy'),
                                name,
                                moment(startDate).format('DD-MM-yyyy'),
                                rankCode,
                                corpId,
                                employeeId
                              )
                            }
                            key={roster.id}
                            enableSmartComm={smartComm}
                          />
                        );
                      } else {
                        return (
                          <Card
                            {...roster}
                            dragIcon={true}
                            dragopen={true}
                            id={roster.staff_key}
                            key={roster.id}
                            remark={null}
                            longremark={null}
                            index={index}
                            enableSmartComm={smartComm}
                                                      />
                        );
                      }
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
            <div className={classes.foot}>
              {publishCtrl && (
                <div className={classes.footbody}>
                  <div>
                    <IconButton
                      className={classes.addbtn}
                      onClick={() => setdialogOpen(true)}
                      id="DutyAssign-IconButton-acl"
                    >
                      <AddIcon className={classes.addicon} />
                      {i18n.t('DUTYASSIGN_ROSTER_ADD_STAFF')}
                    </IconButton>
                  </div>
                  {(enableSmartComm || roleMap[authNameE.dutyAssign_Upload_From_Excel]) && (
                    <div style={{ padding: '.5rem 0' }}>
                      <IconButton
                        className={classes.addbtn}
                        onClick={() => setUploadDialogOpen(true)}
                        id="DutyAssign-IconButton-upload-excel"
                      >
                        <AddIcon className={classes.addicon} />
                        {i18n.t('DUTY_ASSIGN_UPLOAD_BUTTON_TEXT')}
                      </IconButton>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {groupopen && (
        <Group
          backOnclick={() => setgroupopen(false)}
          id="DutyAssign-Group-acm"
          setopen={setopen}
          setgroupopen={setgroupopen}
          setGroup={(props) => {
            setGroupFilter(props);
            getStaffListAPI({ name: filter, group: props, timeStart: startTime, timeEnd: endTime });
          }}
        />
      )}
      {timeopen && (
        <Time
          backOnclick={() => settimeopen(false)}
          id="DutyAssign-Time-acn"
          handleConfirm={(start, end) => {
            setStartTime(start);
            setEndTime(end);
            setTime(`${moment(start, 'HHmm').format('hh:mma')}-${moment(end, 'HHmm').format('hh:mma')}`);
            getStaffListAPI({ name: filter, group: groupfilter, timeStart: start, timeEnd: end });
            setopen(true);
            settimeopen(false);
          }}
        />
      )}
      {!open && !groupopen && !timeopen && (
        <Filter
          backOnclick={() => setopen(true)}
          id="DutyAssign-Filter-aco"
          groupOnclick={() => setgroupopen(true)}
          timeOnclick={() => settimeopen(true)}
        />
      )}
      {dialogOpen && (
        <Dialog
          open={dialogOpen}
          id="DutyAssign-Dialog-acp"
          handleClose={handleDialogClose}
          handleCancel={handleDialogClose}
          handleConfirm={() => handleDialogConfirm(addUsername, dialogFromTime, dialogToTime, rankValue)}
          title={i18n.t('DUTYASSIGN_ROSTER_ADD_TITLE')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          confirmStyle={{
            opacity: handleVerify({ name: addUsername, rank: rankValue, from: dialogFromTime, to: dialogToTime })
              ? 0.2
              : 1,
          }}
        >
          <DialogBody
            rankValue={rankValue}
            handleRank={setRankValue}
            inputValue={addUsername}
            handleInput={handleAddUsername}
            corpId={corpId}
            handleCorpId={setCorpId}
            employeeId={employeeId}
            handleEmployeeId={setEmployeeId}
            startTime={dialogFromTime}
            handleStartTime={handleDialogFromTimeChange}
            endTime={dialogToTime}
            handleEndTime={handleDialogToTimeChange}
            error={error}
            setError={setError}
          />
        </Dialog>
      )}
      {uploadDialogOpen && (
        <Dialog
          open={uploadDialogOpen}
          id="DutyAssign-Dialog-upload-excel"
          handleClose={handleUploadDialogClose}
          handleCancel={handleUploadDialogClose}
          handleConfirm={handleUploadDialogConfirmButtonClick}
          title={<span id="upload-from-excel-dialog-title">{i18n.t('DUTY_ASSIGN_UPLOAD_BUTTON_TEXT')}</span>}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          disabled={handleUploadDialogConfirmButtonDisabled()}
          confirmStyle={{ opacity: handleUploadDialogConfirmButtonDisabled() ? 0.4 : 1 }}
        >
          <Backdrop open={uploadBackdropShow} className={classes.backdrop}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Upload classes={classes} uploads={uploads} handleUploads={handleUploads} />
        </Dialog>
      )}
      <Dialog
        id="DutyAssign-Dialog-upload-alert"
        readOnly
        open={uploadAlert.open}
        title={uploadAlert.title}
        handleClose={handleUploadAlertClose}
        cancel={uploadAlert.status === 'success' ? i18n.t('DUTYASSIGN_CONFIRM') : i18n.t('DUTYASSIGN_CANCEL')}
        handleCancel={handleUploadAlertClose}
      >
        {uploadAlert.content}
      </Dialog>
    </div>
  );
}
